import { PrescriptionType } from "../../../../../../../../../../models/line-item/models/line-item/prescription-glasses.js";
import { getLensDetails } from "../../../../../../../../../../utils/utils/get-lens-details.js";
function getPrescription(typeDetails) {
  if (typeDetails.isExistingCustomer) {
    return {
      type: PrescriptionType.EXISTING_CUSTOMER
    };
  }
  const hasLeftLensPupillaryDistance = Boolean(
    typeDetails.newPrescription?.leftLens.pupillaryDistance
  );
  const hasRightLensPupillaryDistance = Boolean(
    typeDetails.newPrescription?.rightLens.pupillaryDistance
  );
  const hasPupillaryDistanceFile = Boolean(typeDetails.pupillaryDistanceFile);
  const hasLeftAndRightLens = Boolean(typeDetails.newPrescription?.leftLens) && Boolean(typeDetails.newPrescription?.rightLens);
  const hasLeftAndRightPupillaryDistance = hasLeftLensPupillaryDistance && hasRightLensPupillaryDistance;
  if (typeDetails.newPrescription && !typeDetails.isOCRPrescription && typeDetails.prescriptionFile && hasLeftAndRightLens && (hasPupillaryDistanceFile && !hasLeftAndRightPupillaryDistance || !hasPupillaryDistanceFile && hasLeftAndRightPupillaryDistance)) {
    return {
      type: PrescriptionType.PRESCRIPTION_WITH_MANUAL_XOR_FILE_PUPILLARY_DISTANCE,
      prescriptionFile: typeDetails.prescriptionFile.fileName,
      pupillaryDistanceFile: typeDetails.pupillaryDistanceFile?.fileName,
      ...typeDetails.newPrescription?.leftLens && {
        leftLens: getLensDetails(typeDetails.newPrescription.leftLens)
      },
      ...typeDetails.newPrescription?.rightLens && {
        rightLens: getLensDetails(typeDetails.newPrescription.rightLens)
      }
    };
  }
  if (typeDetails.isOCRPrescription && typeDetails.newPrescription && typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
    return {
      type: PrescriptionType.OCR_PRESCRIPTION,
      rightLens: getLensDetails(typeDetails.newPrescription.rightLens),
      leftLens: getLensDetails(typeDetails.newPrescription.leftLens),
      prescriptionFile: typeDetails.prescriptionFile.fileName,
      pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
    };
  }
  if (typeDetails.newPrescription) {
    return {
      type: PrescriptionType.NEW_PRESCRIPTION,
      rightLens: getLensDetails(typeDetails.newPrescription.rightLens),
      leftLens: getLensDetails(typeDetails.newPrescription.leftLens)
    };
  }
  if (typeDetails.prescriptionFile && typeDetails.pupillaryDistanceFile) {
    return {
      type: PrescriptionType.PRESCRIPTION_FILE,
      prescriptionFile: typeDetails.prescriptionFile.fileName,
      pupillaryDistanceFile: typeDetails.pupillaryDistanceFile.fileName
    };
  }
  return {
    type: PrescriptionType.EMAIL_PRESCRIPTION
  };
}
export {
  getPrescription
};
//# sourceMappingURL=get-prescription.js.map
